export default __webpack_public_path__ + "static/acciyo-28de51dab6b6045b1c185ba697d83868.png";